/*

  HEADS UP! THIS IS A GENERATED FILE!

  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OrderFullfillmentCenterSelect } from 'components/Selects';
/* eslint-disable */
import _ from 'lodash';
/* eslint-enable */
import PropTypes from 'prop-types';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Button, Table } from 'reactstrap';
_.mixin(require('lodash-uuid'));

const styles = {
  tableHeader: { cursor: 'pointer' },
};

class TableRow extends React.PureComponent {
  static get propTypes() {
    return {
      editMode: PropTypes.string,
      parentEntity: PropTypes.object.isRequired,
      entity: PropTypes.object.isRequired,
      onChange: PropTypes.func.isRequired,
      onRowDelete: PropTypes.func.isRequired,
      readonly: PropTypes.bool,
    };
  }
  static get defaultProps() {
    return {
      editMode: 'standard',
      readonly: false,
    };
  }

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(key, value) {
    const { onChange, entity } = this.props;
    entity[key] = value;
    onChange(entity.id, entity);
  }

  render() {
    /* eslint-disable no-unused-vars */
    const { entity, onRowDelete, editMode, readonly, sessionUser } = this.props;
    const { parentEntity } = this.props;
    /* eslint-enable */

    return (
      <tr id={entity.id}>
        <td>
          <OrderFullfillmentCenterSelect
            instanceId="select-accessToOfc"
            name="accessToOfc"
            isDisabled={readonly}
            required={true}
            value={entity.accessToOfc}
            onChange={this.handleChange}
          />
        </td>

        {editMode !== 'no-add-no-delete' && (
          <td>
            <Button
              color="secondary"
              className="float-end m-0"
              onClick={() => onRowDelete(entity)}
            >
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </td>
        )}
      </tr>
    );
  }
}

export default class ListComponent extends React.Component {
  static get propTypes() {
    return {
      editMode: PropTypes.string,
      parentEntity: PropTypes.object.isRequired,
      entities: PropTypes.array.isRequired,
      onChange: PropTypes.func.isRequired,
      name: PropTypes.string.isRequired,
    };
  }

  static get defaultProps() {
    return {
      editMode: 'standard',
    };
  }

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.addRow = this.addRow.bind(this);
    this.handleRowDelete = this.handleRowDelete.bind(this);
    this.endRef = React.createRef();
    this.showMore = this.showMore.bind(this);
    this.state = {
      numberOfRowsCurrentlyShowing: 20,
      totalNumberOfRows: this.props.entities?.length || 0,
      hasMore: this.props.entities?.length > 20,
    };
  }

  handleChange(id, entity) {
    const { onChange, entities, name } = this.props;
    const existingIndex = _.findIndex(entities, x => x.id === id);
    if (existingIndex === -1) {
      entities.push(entity);
    } else {
      entities[existingIndex] = { ...entity };
    }
    onChange(name, entities, entity);
  }

  showMore = () => {
    const { entities } = this.props;
    const numberOfRowsToShow = this.state.numberOfRowsCurrentlyShowing + 20;
    const totalNumberOfRows = entities.length || 0;
    this.setState({
      numberOfRowsCurrentlyShowing: numberOfRowsToShow,
      totalNumberOfRows,
      hasMore: totalNumberOfRows > numberOfRowsToShow,
    });
  };

  handleRowDelete(entity) {
    const { onChange, entities, name } = this.props;
    onChange(
      name,
      entities.filter(x => x.id !== entity.id),
      entity,
    );
  }

  async addRow() {
    const id = _.uuid();
    await this.handleChange(id, { id, _recentCreate: true });
    this.endRef.current.scrollIntoView(false);
  }

  render() {
    const { entities, parentEntity, editMode, sessionUser } = this.props;
    const { hasMore } = this.state;
    return (
      <>
        {' '}
        {editMode !== 'no-add-no-delete' && entities.length > 3 && (
          <div>
            <Button onClick={this.addRow}>Lägg till </Button>
          </div>
        )}
        {entities.length > 0 && (
          <InfiniteScroll
            pageStart={0}
            loadMore={() => this.showMore()}
            hasMore={hasMore}
          >
            <Table className="table-striped table-bordered" hover>
              <thead className="thead-light">
                <tr>
                  <th style={styles.tableHeader}>Leveranslager</th>

                  {editMode !== 'no-add-no-delete' && <th> </th>}
                </tr>
              </thead>
              <tbody>
                {entities.map((entity, i) => {
                  if (this.state.numberOfRowsCurrentlyShowing < i) {
                    return <></>;
                  }

                  return (
                    <TableRow
                      key={entity.id}
                      editMode={editMode}
                      parentEntity={parentEntity}
                      entity={entity}
                      onChange={this.handleChange}
                      onRowDelete={this.handleRowDelete}
                      sessionUser={sessionUser}
                    />
                  );
                })}
              </tbody>
            </Table>
          </InfiniteScroll>
        )}
        {editMode !== 'no-add-no-delete' && (
          <div>
            <div ref={this.endRef} />
            <Button onClick={this.addRow}>Lägg till </Button>
          </div>
        )}
      </>
    );
  }
}
